import { Injectable } from '@angular/core';
import { HttpErrorHandler, HandleError } from '@app/shared/services/http-error-handler.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { HeadersSetterHelper } from '@app/shared/helpers/http-headers-setter-helper';
import { Observable } from 'rxjs';
import { ISpringResponseBody, observeTypes } from '@app/shared/interfaces/response-interfaces';
import { AppConfig } from '@app/config/app.config';
import { catchError } from 'rxjs/operators';
import { IConsentElement, ConsentRequest } from '@app/certificates/consents/consent';

@Injectable()
export class ConsentsService {
  private handleError: HandleError;
  private headerHelper: any;

  constructor(
    private httpErrorHandler: HttpErrorHandler,
    private http: HttpClient,
    private store: Store<any>
  ) {
    this.handleError = httpErrorHandler.createHandleError('ConsentsService');
    this.headerHelper = new HeadersSetterHelper(this.store);
  }

   getAll(options: ConsentRequest): Observable<ISpringResponseBody | any> {
       return this.http.get<ISpringResponseBody>(
      AppConfig.endpoints.consents,
      this.buildRequestOptions(options)
    ).pipe(
      catchError(this.handleError('getAll'))
    );
  }

  public getSignedConsentFile(consentId: number): Observable<any> {
    return this.http.get(
      AppConfig.endpoints.storage.getConsent + '/' + consentId,
      this.headerHelper.fileOptions(observeTypes.RESPONSE, 'blob')
    ).pipe(
      catchError(this.handleError('getFile'))
    );
  }

  updateConsent(consent: IConsentElement, revokeReason: string) {
    return this.http.put<ISpringResponseBody>(
        AppConfig.endpoints.consents + '/revoke/' + consent.id, { revokeReason}, this.headerHelper.options(observeTypes.BODY))
        .pipe(
          catchError(this.handleError('revokeConsent'))
        );
  }

  buildRequestOptions(options: ConsentRequest) {
    let params = new HttpParams();
    // setting request options
    Object.keys(options).forEach((key) => {
      if (key === 'textToShow') {
        params = params.set(key, encodeURIComponent(options[key]));
      } else {
        params = params.set(key, options[key]);
      }
    });
    return this.headerHelper.historyOptions(observeTypes.BODY, params);
  }
}
